import { render, staticRenderFns } from "./bFormPage.vue?vue&type=template&id=42e1d93e&scoped=true&"
import script from "./bFormPage.vue?vue&type=script&lang=js&"
export * from "./bFormPage.vue?vue&type=script&lang=js&"
import style0 from "./bFormPage.vue?vue&type=style&index=0&id=42e1d93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1d93e",
  null
  
)

export default component.exports